<template>
  <div class="results">
    <transition
      :name="effect"
      mode="out-in"
    >
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Results',
  data: () => ({
    effect: 'slide-fade'
  }),
  watch: {
    $route(to, from) {
      if (to.path === '/results/filter') {
        this.effect = 'leave-fade'
      } else {
        this.effect = 'slide-fade'
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../../static/stylesheets/variables';
  @import '../../../static/stylesheets/components/orders/empty-cart';

  .results {
    height: 100%;
    padding-top: $mainHeaderHeight;

    .slide-fade-enter-active {
      transition: all 0.3s ease;
    }
    .slide-fade-leave-active {
      transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .slide-fade-enter {
      transform: translateY(300px);
      opacity: 0;
    }
    .slide-fade-leave-to {
      transform: translateY(-400px);
      opacity: 0;
    }

    .leave-fade-enter-active {
      transition: all 0.3s ease;
    }
    .leave-fade-leave-active {
      transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .leave-fade-enter {
      transform: translateY(-450px);
      opacity: 0;
    }
    .leave-fade-leave-to {
      transform: translateY(450px);
      opacity: 0;
    }

    .alternative-subheader {
      position: initial !important;
    }
  }

  .export-results.modals .md-dialog {
    min-width: 660px;
    min-height: 230px;
    border-radius: 7px;

    &-title {
      padding: 32px 34px 13px;
      font-size: 24px;
      font-weight: 300;
      letter-spacing: -0.3px;
      color: rgba(96, 96, 96, 0.87);
    }

    .close-button {
      position: absolute;
      top: 23px;
      right: 38px;
    }

    p {
      display: flex;
      justify-content: center;
      flex-direction: column;
      font-size: 18px;
      letter-spacing: -0.2px;
      text-align: center;
      color: #303030;
      margin-bottom: 10px;
    }
  }
</style>
